import React from 'react';
import { useEffect, useState, useRef } from 'react';
import Loader from '../components/Loader';
import { getSafeUrl } from '../helpers/safeUrl';

const IFrame = (props) => {
    const {currentDoc} = props;
    const safeArchiveUrl = getSafeUrl(currentDoc?.archive_url);
    const [iframeLoading, setIframeLoading] = useState(false);
    const iframe = useRef(null);

    useEffect(() => {
        setIframeLoading(true);
    }, []);

    return (
        <>
            {safeArchiveUrl && iframeLoading && <Loader />}
            
            {safeArchiveUrl && <iframe className="border border-gray-300 h-[460px] md:h-[800px]" width="100%" height="100%" ref={iframe} title={currentDoc?.title} aria-label={currentDoc?.title} src={safeArchiveUrl} onLoad={() => setIframeLoading(false)} />}
            
        </>
    )
}

export default IFrame;
